import EditSubscriptionFormContainer from './EditSubscriptionFormContainer';
import AddSubscription from './services/AddSubscription';
import GetSubscription from './services/GetSubscription';
import EditSubscription from './services/EditSubscription';
import stores from './stores';

const EditSubscriptionForm = {
  path: ['/edit-subscription/','/add-subscription'],
  exact: false,
  services: [new AddSubscription(), new GetSubscription(), new EditSubscription()],
  stores: stores,
  component: EditSubscriptionFormContainer
};

export default EditSubscriptionForm;
